import { IoPersonOutline } from "react-icons/io5";
import {
  getHeaderClass,
  getHeaderIcon,
  getHeaderTitle
} from "../../utils/getHeaderDetails";
import { useLocation } from "react-router-dom";
import "./header.css";
import { useSelector } from "react-redux";
import { getTranslation } from "../../utils/getTranslation";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";
import { useGetUserRoles } from "../../hooks/useGetUserRoles";
import Loading from "../../components/Loading/Loading";

const Header = () => {
  let location = useLocation();
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.userInfo);
  const [isLoading, setIsLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const { roles, getUserRoles, setUserRole } = useGetUserRoles(t);
  const isMultiRole = useSelector((state) => state.userInfo?.hasMultiRol) ?? false;

  const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPayload({ ...payload, [name]: value });
    setUserRole(value);
    setIsLoading(true);
	};

  useEffect(()=>{
    if (userInfo) {
      setPayload({roleId: userInfo?.roleId});
    }
  }, [userInfo])

  const getRoleSection = () => {
    if (isMultiRole) {
      return (<Dropdown
					handleChange={handleInputChange}
					onOpen={() => getUserRoles()}
					data={roles}
					value={payload.roleId}
					error={""}
					disabled={false}
					textField='name'
					valueField='id'
					className='col-lg-12 '
					label={null}
					name='roleId'
				/>);
    }

    return (<p>{getTranslation(userInfo?.role, t)}</p>)
  }

  return (
    <div className="header">
      <Loading isLoading={isLoading} />
      <div className={"details " + getHeaderClass(location.pathname)}>
        {userInfo && getHeaderIcon(location.pathname)}
        <h2>
          {userInfo && getTranslation(getHeaderTitle(location.pathname), t)}
        </h2>
      </div>
      <div className="profile">
        <div className="container">
          <span className="name">{`${userInfo.firstname ?? ""} ${
            userInfo.lastname ?? ""
          }`}</span>

          {getRoleSection()}
        </div>
        <IoPersonOutline className="icon" />
      </div>
    </div>
  );
};

export default Header;
